import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    auth: false,
  },
  reducers: {
    isLoggedIn: (state) => {
      state.auth = true;
    },
    isLoggedOut: (state) => {
      state.auth = false;
      // Cookies.remove("authToken");
      
    },
  },
});

export const { isLoggedIn, isLoggedOut } = authSlice.actions;
export default authSlice.reducer;
